import { additionalPalette, makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()((theme) => ({
  intro: {
    paddingBottom: theme.spacing(2)
  },
  list: {
    maxHeight: '50vh',
    overflowY: 'auto',
    paddingRight: theme.spacing(1)
  },
  // DragAndDrop wraps its child in a flex container, so claim the width.
  row: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: additionalPalette.lightBlue.main
    }
  },
  rowNotAsked: {
    opacity: 0.6
  },
  label: {
    flex: '0 0 auto',
    minWidth: theme.spacing(4)
  },
  title: {
    flex: 1,
    minWidth: 0
  },
  notAsked: {
    flex: '0 0 auto',
    color: additionalPalette.darkGrey.main,
    whiteSpace: 'nowrap'
  }
}))

export default useStyles
